<div #list class="element-row" style="align-items: center;"
  [style.width.px]="width" [style.width]="width !== undefined ? width : '100%'"
  [style.height.px]="height" [style.height]="height !== undefined ? height : '100%'">
  <ng-template ngFor let-item [ngForOf]="codeCheckBoxListModel.codeList" let-i="index">
    <div class="checkbox-group" [class.selected]="lastClickId === codeDiv + item.CodeValue"
      (change)="onChange(codeDiv + item.CodeValue)">
      <label>
        <input type="checkbox" [tabindex]="tabindex" [(ngModel)]="item.selectedValue" [disabled]="disabled"
          class="checkbox">{{ item.codeValueName  }}</label>
    </div>
  </ng-template>
</div>
